import type { Traveler } from "@b2bportal/traveler-api";
import type { TravelerInformationContext as LibTravelerInformationContext } from "@checkout/states";
import type { PersonId } from "@hopper-b2b/types";

export interface TravelerInformationContext
  extends LibTravelerInformationContext {
  // Following are copied from smcc. HSBC doesn't use it yet for flights and hotels.
  // Should move to libs/checkout when confirmed.

  // Infant travelers ( flights only )
  currentInfantId?: PersonId;
  selectedLapInfantIds: Array<PersonId>;

  infantOnlyError: false;
  addPassport: false;
  isValidated: false;
  numTravelerAlertDismissed: boolean;
}

export const getInitialTravelerInfoContext =
  (): TravelerInformationContext => ({
    selectedTravelerIds: [] as Array<PersonId>,
    travelers: [] as Array<Traveler>,
    numTravelerAlertDismissed: false,
    visited: false,
    currentInfantId: undefined,
    selectedLapInfantIds: [],
    infantOnlyError: false,
    addPassport: false,
    isValidated: false,
  });
